import React, { useEffect, useState } from "react";
import { getAppAnalytics } from "../analytics.service";
import DailyIcon from "../../../Assets/DailyIcon.svg";
import MonthlyIcon from "../../../Assets/MonthlyIcon.svg";
import StickinessIcon from "../../../Assets/StickinessIcon.svg";
import QuestionMark from "../../../Assets/questionMark.svg";
import { Tooltip } from "@material-ui/core";

const DMS = ({ app }) => {

    const [dau, setDau] = useState();
    const [mau, setMau] = useState();
    const [stickiness, setStickiness] = useState();

    useEffect(async () => {
        const res = await getAppAnalytics('usage', app?.packageName, app?.platform,app?.title);
        let dauVal = Math.round((res.data.data.dailyActiveUser.TotalUser) * 100) / 100
        dauVal = dauVal ? dauVal.toFixed(2) : dauVal
        setDau(dauVal);
        setMau(res.data.data.monthlyActiveUser.TotalUser);
        let StickinessVal = (Math.round((res.data.data.stickyNess) * 100) / 100)*100
        StickinessVal = StickinessVal ? StickinessVal.toFixed(2) : StickinessVal
        setStickiness(StickinessVal);
    }, []);

    return (
        <>
            <div className="card p_all-20 flex-point-33">
                <div className="d-flex d-flex-column z-index-2">
                    <div className="d-flex">
                        <div className="font-bold font-size-14">
                            Daily active user
                        </div>
                        <div className="pl-7">
                            <Tooltip className="pb-6" title="The Daily Active User is calculated as the total numbers of unique users on a day,averaged over the last 30 days.">
                                <img
                                    src={QuestionMark}
                                    alt=""
                                />
                            </Tooltip>
                        </div>
                    </div>
                    {dau !== 0 ? (
                        <div>
                            <h1 className="pt-10">{dau}</h1>
                        </div>
                    ) : (<span className="text-gray font-size-32 font-bold">NA</span>)}
                </div>

                <div>
                    <img
                        className="icon pl-42 z-index-1"
                        src={DailyIcon}
                        alt=""
                    />
                </div>
            </div>
            <div className="card p_all-20 flex-point-33">
                <div className="d-flex d-flex-column z-index-2">
                    <div className="d-flex">
                        <div className="font-bold font-size-14">
                            Monthly active user
                        </div>
                        <div className="pl-7">
                            <Tooltip className="pb-6" title="The Monthly Active User is calculated as the total numbers of unique users in the last 30 days.">
                                <img
                                    src={QuestionMark}
                                    alt=""
                                />
                            </Tooltip>
                        </div>
                    </div>
                    {mau !== 0 ? (
                        <div>
                            <h1 className="pt-10">{mau}</h1>
                        </div>
                    ) :
                        (
                            <span className="text-gray font-size-32 font-bold">NA</span>
                        )
                    }

                </div>
                <div>
                    <img
                        className="icon pl-42 z-index-1"
                        src={MonthlyIcon}
                        alt=""
                    />
                </div>
            </div>
            <div className="card p_all-20 flex-point-33">
                <div className="d-flex d-flex-column z-index-2">
                    <div className="d-flex">
                        <div className="font-bold font-size-14">
                            Stickiness - DAU/MAU
                        </div>
                        <div className="pl-7">
                            <Tooltip className="pb-6" title="The Stickiness is calculated as the ratio of Daily and Monthly Active Users over the last 30 days.">
                                <img
                                    src={QuestionMark}
                                    alt=""
                                />
                            </Tooltip>
                        </div>
                    </div>
                    {(stickiness === null || stickiness === 0) ? (
                        <span className="text-gray font-size-32 font-bold">NA</span>
                    ) : (
                        <div className="d-flex">
                        <h1 className="pt-10">{stickiness}</h1><span className="mtc-15 mlc-3 font-size-20 pt-10">%</span>
                    </div>
                    )}
                </div>
                <div className="icon z-index-1">
                    <img
                        className="icon pl-42"
                        src={StickinessIcon}
                        alt=""
                    />
                </div>
            </div>
        </>
    )
}

export default DMS;